import React, { useRef, useState, useEffect } from 'react';
import './styles.scss';

const EasyZoom = ({ imageUrl, initialScale = 1, maxScale = 3, previewScale = 2 }) => {
    const [isHovering, setIsHovering] = useState(false);
    const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
    const imageRef = useRef(null);
    const previewRef = useRef(null);

    // �������������Ƴ��¼�  
    const handleMouseEnter = () => {
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    // ��������ƶ��¼�������hoverλ��  
    const handleMouseMove = (event) => {
        if (imageRef.current && previewRef.current) {
            const rect = imageRef.current.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width;
            const y = (event.clientY - rect.top) / rect.height;
            setHoverPosition({ x, y });
        }
    };

    // ��ȾԤ��ͼƬ������hoverλ�ã�  
    const renderPreview = () => {
        if (!isHovering || !imageUrl) return null;

        const style = {
            backgroundImage: `url(${imageUrl})`,
            backgroundPosition: `${hoverPosition.x * 100}% ${hoverPosition.y * 100}%`,
            backgroundSize: `${100 * previewScale}%`,
            width: `${previewScale * 80}%`,
            height: `${previewScale * 80}%`,
        };

        return (
            <div
                ref={previewRef}
                className="easyzoom-preview"
                style={style}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
            />
        );
    };

    return (
        <div
            ref={imageRef}
            className="easyzoom-container"
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={{
                position: 'relative',
                width: '378px', // ������������Ҫ�ĳߴ�  
                height: '378px'
            }}
        >
            <img src={imageUrl} alt="" style={{ width: '100%', height: 'auto' }} />
            {renderPreview()}
        </div>
    );
};

export default EasyZoom;

